import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        bg-electric-yellow text-black font-bold py-4 px-8 rounded-md
        shadow-emerald hover:shadow-emerald-hover transition-shadow duration-300
        uppercase tracking-wider text-sm md:text-base
        ${className}
      `} {...props} data-id="element-299">
      {children}
    </motion.button>;
}